  <template>
  <div class="ding-biMobile">
    <div class="group clearfix">
      <div class="ding-biMobile-tit">集团看板</div>
      <div v-if="biMobileList && biMobileList.length > 0 && !noAccess">
        <div
          class="ding-biMobile-card card-group"
          @click="toPath(card)"
          v-for="(card, index) in biMobileList"
          :key="index"
        >
          <div class="img-cont">
            <img
              class="img"
              src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/icons／line／看板.svg"
              alt
            />
            <span class="img-cont-tit">DASHBOARD</span>
          </div>
          <div class="card-cont">
            <span>{{yearNow}}{{ishalf}}年</span>
            {{card.name}}
          </div>
        </div>
      </div>
      <div class="ding-comingSoon" v-if="biMobileList.length === 0 && !noAccess">
        <img
          src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/await@2x.png"
          alt
        />
        <div class="comingSoon-hint">即将推出 敬请期待</div>
      </div>
      <div class="ding-comingSoon ding-noAccess" v-if="noAccess">
        <img
          src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/qx@2x.png"
          alt
        />
        <div class="comingSoon-hint">
          非常抱歉，您暂无权限查看！
          <br />请联系管理人员开通！
        </div>
      </div>
    </div>

    <div class="ent clearfix">
      <div class="ding-biMobile-tit">企业看板</div>
      <div class="ding-comingSoon">
        <img
          src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/await@2x.png"
          alt
        />
        <div class="comingSoon-hint">即将推出 敬请期待</div>
      </div>
    </div>
  </div>
</template>
<script>
  import * as customSensors from '@/assets/js/sensors'
export default {
  props: [],
  data() {
    return {
      yearNow: "2017",
      ishalf: "",
      biMobileList: [],
      noAccess: false,
    };
  },
  components: {},
  created() {
    this.getPage();
    this.yearNow = new Date().getFullYear();
    var month = parseInt(new Date().getMonth()) + 1;
    if (month < 7) {
      //上半年
      this.ishalf = "上半";
    } else {
      //下半年
      this.ishalf = "";
    }
  },
  mounted() {
    setTimeout(() => {
      try{
        customSensors.customBulletinBoardPageView()
      } catch (e) {}
    }, 500)
  },
  methods: {
    getXenv() {
      const host = window.location.host;
      return host.indexOf("test") > -1 ||
        host.indexOf("local") > -1 ||
        host.indexOf("127.0.0.1") > -1 ||
        // ? "test"
        host.indexOf("dev") > -1
        ? "test"
        : host.indexOf("uat") > -1
        ? "uat"
        : "";
    },
    // 跳转
    toPath(val) {
      try{
        customSensors.customBulletinBoardClick({
          bulletin_board_type: '集团看板',
          bulletin_board_name: val.name
        })
      } catch (e) {}

      let url = "";
      if (this.getXenv() === "") {
        url = `http://${this.getXenv()}${val.url}?flag=dingding`;
      } else {
        url = `http://${this.getXenv()}-${val.url}?flag=dingding`;
      }

      // let url = "http://local.onelinkplus.com:4055/#/home"
      // window.open(val.url + "?functionId="+ val.functionId);
      window.open(url);
    },
    // 获取数据
    getPage() {
      this.$axios
        .get("/onelink.mdata.bi.api/dingDing/workbench/getFunctionList")
        .then((res) => {
          if (res.data.code === 0) {
            this.biMobileList = res.data.rows;
            this.noAccess = false;
          } else if (res.data.code == 10000005) {
            this.$router.push({
              path: "/login",
              query: { redirectURL: window.location.href },
            });
          } else if (res.data.code == 10000009) {
            this.noAccess = true;
          } else {
            this.$message({
              type: "error",
              message: res.data.errorMsg,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/dingWorkbench/biMobile.vue